import { useEffect, useMemo } from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

type MapEntityDrawerMethods = {
  minimizeEntityDrawer: () => void;
  restoreEntityDrawer: () => void;
  snapEntityDrawerTo: (snapPointPct: number) => void;
};

const mapEntityDrawerMethodsAtom = atom<MapEntityDrawerMethods | null>({
  key: 'MAP_ENTITY_DRAWER_METHODS',
  default: null,
});

export const useMapEntityDrawer = (): MapEntityDrawerMethods => {
  const methods = useRecoilValue(mapEntityDrawerMethodsAtom);

  return useMemo(
    () => ({
      minimizeEntityDrawer: () => methods?.minimizeEntityDrawer(),
      restoreEntityDrawer: () => methods?.restoreEntityDrawer(),
      snapEntityDrawerTo: (snapPointPct: number) =>
        methods?.snapEntityDrawerTo(snapPointPct),
    }),
    [methods],
  );
};

export const useRegisterMapEntityDrawer = (
  /** methods must be a memoized object */
  methods: MapEntityDrawerMethods,
): void => {
  const setMethods = useSetRecoilState(mapEntityDrawerMethodsAtom);

  useEffect(() => {
    setMethods(methods);
    return () => setMethods(null);
  }, [methods, setMethods]);
};
